.button {
  display: inline-grid; place-items: center; flex: none;
  border: 0; border-radius: var(--radius-full); background: transparent; color: var(--color-text-secondary);
  transition: background-color var(--duration-fast) ease, color var(--duration-fast) ease,
    transform var(--duration-instant) var(--ease-out);
}
.md { width: 40px; height: 40px; }
.sm { width: 32px; height: 32px; }
.button svg { width: 20px; height: 20px; }
.sm svg { width: 18px; height: 18px; }
.button:hover:not(:disabled) { background: var(--color-surface-hover); color: var(--color-text); }
.button:active:not(:disabled) { transform: scale(0.94); }
.button[aria-pressed="true"] { background: var(--color-surface-selected); color: var(--color-primary-text); }
.button:disabled { opacity: 0.4; cursor: not-allowed; }
.button:focus-visible { border-radius: var(--radius-full); }
